<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal :title="state.modalTitle" :width="1000" :open="true" :confirmLoading="state.loading" @ok="onFormSubmit"
        @cancel="
            () => {
                emit('cancel')
            }
        ">
        <a-spin :spinning="state.loading">
            <a-form ref="ruleForm" :model="formState" v-bind="formLayout" :rules="rules">
                <a-form-item label="报销总额" name="money" required>
                    <a-input style="width: 200px" type="number" placeholder="请输入报销金额" v-model:value="formState.money"
                        addon-after="元"></a-input>
                </a-form-item>
                <a-form-item label="费用发生时间" name="occurrence_time" required>
                    <a-date-picker :format="format" showTime :value="formState.occurrence_time"
                        @change="(dates) => formState.occurrence_time = dates" placeholder="请选择费用发生时间"></a-date-picker>
                </a-form-item>

                <a-form-item label="费用类型" name="type" required>
                    <a-select allow-clear v-model:value="formState.type" placeholder="请输入费用类型">
                        <a-select-option :value="1">房租</a-select-option>
                        <a-select-option :value="2">物业费</a-select-option>
                        <a-select-option :value="3">电费</a-select-option>
                        <a-select-option :value="4">水费</a-select-option>
                        <a-select-option :value="5">办公费</a-select-option>
                        <a-select-option :value="6">商务费</a-select-option>
                        <a-select-option :value="7">工资或劳务费</a-select-option>
                        <a-select-option :value="8">福利</a-select-option>
                        <a-select-option :value="9">差旅费</a-select-option>
                        <a-select-option :value="10">税费</a-select-option>
                        <a-select-option :value="99">其他</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="所属平台" name="buss_platform_id" required>
                    <a-select allow-clear v-model:value="formState.buss_platform_id" placeholder="请选择平台"
                        @change="changePlatform">
                        <a-select-option v-for="(item, index) in state.platformList" :key="index"
                            :value="item.buss_platform_id">{{ item.platform_name }}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="报销类型" name="claim_type" required v-if="formState.buss_platform_id">
                    <a-select allow-clear v-model:value="formState.claim_type" placeholder="请输入">
                        <a-select-option v-for="item in state.claim_types" :value="item.id">{{ item.name
                        }}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="费用说明" name="reason">
                    <a-textarea v-model:value="formState.reason" placeholder="请输入费用说明"></a-textarea>
                </a-form-item>
                <a-form-item label="本次报销是否有发票" name="hasfapiao">
                    <a-radio-group v-model:value="formState.hasfapiao">
                        <a-radio :value="1">有</a-radio>
                        <a-radio :value="2">无</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="附件" name="accessory">
                    <Upload :upload_path="`public/uploads/manage/报销附件/${dayjs().format('YYYYMM')}/`" uploadType="text"
                        :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png']" :limitation="1"
                        v-model:value="formState.accessory" uploadText="上传附件">
                    </Upload>
                </a-form-item>
                <a-form-item label="报销人" name="vesting_party" required>
                    <a-input v-model:value="formState.vesting_party" placeholder="请输入报销人"></a-input>
                </a-form-item>
                <a-form-item label="仅谁可以看（默认不填）" name="lookerids">
                    <UserPick v-model:value="formState.lookerids" mode="multiple" placeholder="填了后只有选中的用户可以看到">
                    </UserPick>
                </a-form-item>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script lang="ts" setup name="createTemplate">
import { Upload } from '@/components'
import { reactive, ref, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import dayjs from 'dayjs'
import { useStore } from 'vuex'
import UserPick from '@/components/base/UserPick.vue'
const $store = useStore()
const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})
const format = 'YYYY-MM-DD HH:mm:ss'
const emit = defineEmits(['cancel', 'ok'])
const ruleForm = ref()
const rules = {}
const formLayout = {
    labelCol: {
        xs: { span: 7 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 10 },
        sm: { span: 10 }
    }
}

interface state {
    modalTitle: string
    platformList: any[]
    claim_types: any[]
    loading: boolean
}
const state = reactive<state>({
    modalTitle: '新增报销',
    platformList: [],
    claim_types: [],
    loading: false
})
let formState = reactive<any>({
    vesting_party: null,
    accessory: null,
    reason: null,
    occurrence_time: ref(dayjs()),
    money: null,
    buss_platform_id: null,
    type: null,
    claim_type: null,
    lookerids: [],
    hasfapiao: null
})

onMounted(() => {
    formState.vesting_party = $store.state.user.userInfo.idcard_name
    if (props.detailData?.id) {
        state.modalTitle = '编辑报销'
        queryDetail(props.detailData.id)
    }
    queryClaimTypes()
})

const queryDetail = (id) => {
    state.loading = true
    let requeryParam = {
        url: `/admin/v1/claimExpenses/${id}/edit`,
        method: 'get'
    }
    baseService(requeryParam).then((res) => {
        state.loading = false
        Object.assign(formState, res.data)
        formState.occurrence_time = dayjs(formState.occurrence_time, format)
    }).catch((res) => {
        state.loading = false
        if (res.msg) {
            message.error(res.msg)
        } else {
            message.error('操作失败')
        }
    })
}
const queryClaimTypes = () => {
    let requeryParam = {
        url: `/admin/v1/claimExpenses/create`,
        method: 'get'
    }
    baseService(requeryParam).then((res) => {
        state.platformList = res.data
        if (formState.buss_platform_id) {
            let platform = state.platformList.find((item) => item.buss_platform_id == formState.buss_platform_id)
            state.claim_types = platform.baoxiao_type
        }
    })
}
const changePlatform = () => {
    let platform = state.platformList.find((item) => item.buss_platform_id == formState.buss_platform_id)
    formState.claim_type = null
    state.claim_types = platform.baoxiao_type
}
const onFormSubmit = () => {
    ruleForm.value
        .validate()
        .then(() => {
            state.loading = true
            if (props.detailData?.id > 0) {
                let requeryParam = {
                    url: '/admin/v1/claimExpenses/' + props.detailData.id,
                    method: 'put',
                    data: formState
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('ok')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            } else {
                let requeryParam = {
                    url: '/admin/v1/claimExpenses',
                    method: 'post',
                    data: formState
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('cancel')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            }
        })
        .catch(() => { })
}
</script>

<style lang="less" scoped></style>
